import { Link, Outlet, useLocation } from 'react-router-dom';
import { Link2, Smartphone, User, BookOpen, Star } from 'lucide-react';

export default function AdminSettings() {
  const location = useLocation();

  const tabs = [
    {
      id: 'integrations',
      path: '/admin-settings/integrations',
      label: 'Integrasjoner',
      icon: Link2,
      description: 'Administrer Xtramile-integrasjoner for dine medlemsorganisasjoner'
    },
    {
      id: 'literature-requests',
      path: '/admin-settings/literature-requests',
      label: 'Litteraturforespørsler',
      icon: Star,
      description: 'Godkjenn eller avvis forespørsler om kurerte kilder'
    },
    {
      id: 'devices',
      path: '/admin-settings/devices',
      label: 'Mine enheter',
      icon: Smartphone
    },
    {
      id: 'account',
      path: '/admin-settings/account',
      label: 'Konto',
      icon: User
    },
    {
      id: 'documentation',
      path: '/admin-settings/documentation',
      label: 'Dokumentasjon',
      icon: BookOpen
    },
  ];

  const currentPath = location.pathname;
  const activeTab = tabs.find(tab => currentPath.startsWith(tab.path))?.id || 'integrations';

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Innstillinger</h1>
        <p className="mt-1 text-sm text-gray-500">
          Administrer innstillinger for ditt studieforbund
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white rounded-lg shadow-sm border">
        <div className="border-b">
          <nav className="flex flex-wrap -mb-px">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;

              return (
                <Link
                  key={tab.id}
                  to={tab.path}
                  className={`px-4 py-3 text-sm font-medium border-b-2 transition-colors flex items-center gap-2 ${
                    isActive
                      ? 'border-kf-primary text-kf-primary'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <Icon size={18} />
                  {tab.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Content */}
      <Outlet />
    </div>
  );
}
